<!-- 
  列表页-筛选项设置
 -->

<template>
  <div class="transfer">
    <el-dialog
      :visible.sync="dialogVisible"
      width="740px"
      title="常用筛选设置"
      :before-close="closeDialog">
      <el-transfer
      v-model="value"
      :data="origin"
      :props="{
        key: 'attr',
        label: 'attrName'
      }"
      :titles="['所有字段', '已选字段']">
      </el-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'

export default {
  props: {
    // Type
    type: {
      type: Number,
      required: true
    },
    templateId: {
      default: ''
    }
  },
  data () {
    return {
      dialogVisible: false,
      value: [],
      origin: []
    }
  },
  created () {
    let url = '/listSearchSet.html'
    let params = {
      type: this.type,
      templateId: this.templateId
    }
    api.post(url, params, (data) => {
      this.dialogVisible = true
      this.origin = data.all
      this.value = data.checked
    })
  },
  methods: {
    handleSubmit () {
      let url = '/saveSearchItems.html'
      let params = {
        type: this.type,
        searchItems: this.value,
        templateId: this.templateId
      }
      api.post(url, params, (data) => {
        this.closeDialog()
        Message({
          type: 'success',
          message: data.msg || '设置成功!'
        })
        this.$emit('refresh')
      })
    },
    // 关闭前执行
    closeDialog () {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style lang="less">
  .transfer {
    .el-transfer {
      padding-left: 122px;
      .el-transfer-panel__item {
        margin-left: 0 !important;
        display: block;
        .el-checkbox__label {
          font-size: 13px;
          color: #666;
        }
      }
      .el-transfer__buttons {
        padding: 0 10px;
        width: 45px;
        .el-button {
          margin-left: 0;
          margin-right: 0;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// set-filter.vue?6dccf072